module.exports = __webpack_public_path__ + "static/media/DieSeeleDerSonneCover.e037eea2.jpg";